import { Box, Typography } from '@mui/material'
import React from 'react'

export default function UserBubble({ text }: { text: string }) {
  return (
    <Box
      sx={{
        alignSelf: 'flex-end',
        maxWidth: '85%',
        bgcolor: 'action.selected',
        color: 'text.primary',
        px: 1.5,
        py: 1,
        borderRadius: 2,
        borderTopRightRadius: 4,
      }}
    >
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{text}</Typography>
    </Box>
  )
}
